import React, { Component } from 'react';
import axios from 'axios';
import {QRCodeCanvas} from 'qrcode.react';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Home extends Component {


  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      success: '',
      error: '',
      getuuid: '',
      keyword: '',
      tumsiralama: [],
      ilkucsiralama: [],
      count: 180
    };

    this.sidebarShow = this.sidebarShow.bind(this);

  }

  sidebarShow(event) {
    document.getElementById("sidebar").classList.add('active_sidebar')
  }

  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span className="">
          <NavLink className="d-none me-2 small link-dark text-decoration-none" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="text-decoration-none" to="/user/logout">
            Çıkış Yap
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }




  componentDidMount() {
  
    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var auth2 = localStorage.getItem('auth');
  
  	console.log(uid);
  	console.log(auth);
  	console.log(auth2);
  
    var self = this;
  
    this.serverRequest = axios.get('https://api.efeskiyafetportali.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic " + auth2}
    })
    .then(function(result){
      var userDate = new Date(parseInt(result.data.created["0"].value, 10)*1000);
      self.setState({
        'name': result.data.name["0"].value,
        'field_ad': result.data.field_ad["0"].value,
        'field_soyad': result.data.field_soyad["0"].value,
        'field_alan': result.data.field_alan["0"].value,
        'date': userDate.toISOString()
      });
    })

  
  
  
  
  
  }





  render(){
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
        return (
        <section className="main_content dashboard_part">
            <div className="container pt-3">
                <div className="row">
                    <div className="col-lg-4">
                     <div className="alan"> {this.state.field_alan} </div>
                        <div className="header_iner">
                            <div className="header_right d-flex justify-content-between align-items-center">
                                <NavLink className="text-decoration-none me-3" to="/user/profile"> {this.state.field_ad} {this.state.field_soyad}</NavLink>
                                <div className="text-center me-3">{this.renderUserLinks()}</div>
                            </div>
                            	<div><NavLink className="text-decoration-none me-3" to="/order">Siparişler</NavLink></div>
                        </div>
                    </div>
                    <div className="col-sm-8 mb-4 mb-lg-0">
                        <div className="border border-white rounded-4">
                            
                        
                        
                        
                        
                        </div>
                    </div>
                </div>
            </div>
        </section>


        );
    } else {
        return (



          <div className="row top-buffer">
            <Redirect to="/user/login" />
          </div>



        );
    }
  }
}

export default Home



// WEBPACK FOOTER //
// src/components/home.jsx